import { Container, Grid, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppToolbar } from '../../components/AppToolbar';
import { AppButton } from '../../components/AppButton';
import { ArrowBack } from '@mui/icons-material';


export function ClassesPreview() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const instance_id = params.get('instance_id');
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(`/${location.pathname.includes('periodizations') ? 'periodizations' : 'classes'}`);
    }

    // Base URL for the TV displays
    const baseUrl = process.env.REACT_APP_TVS_SOFTWARE_BASE_PATH || 'https://displays.basezero.pt';

    // URLs for each TV type
    const exerciseTv1Url = `${baseUrl}/exercise?tv=1&instance_id=${instance_id}&autostart=true`;
    const exerciseTv2Url = `${baseUrl}/exercise?tv=2&instance_id=${instance_id}&autostart=true`;
    const exerciseTv3Url = `${baseUrl}/exercise?tv=3&instance_id=${instance_id}&autostart=true`;
    const timerTvUrl = `${baseUrl}/timer?tv=4&instance_id=${instance_id}&autostart=true`;
    const scheduleTvUrl = `${baseUrl}/schedule?tv=5&instance_id=${instance_id}&autostart=true`;
    const movementTvUrl = `${baseUrl}/timer?tv=4&instance_id=${instance_id}&autostart=false`;

    const horizontalStyle = {
        width: '1920px',
        height: '1080px',
        transform: 'scale(0.3)', // Scale to fit
        transformOrigin: 'top left',
    };

    const verticalStyle = {
        width: '1080px',
        height: '1920px',
        transform: 'scale(0.3)', // Scale to fit
        transformOrigin: 'top left',
    };

    return (
        <Container>
            <AppToolbar title={`Preview Class workout`}>
                <AppButton startIcon={<ArrowBack />} onClick={handleBack}>
                    Back
                </AppButton>
            </AppToolbar>

            {/* Bottom section with 3 Exercise TVs */}
            <Grid container spacing={2} style={{ height: 700 }}>
                {/* Exercise TV 3 */}
                <Grid item xs={4}>
                    <Typography variant="h6" gutterBottom>Exercise TV 3</Typography>
                    <iframe src={exerciseTv3Url} style={verticalStyle} title="Exercise TV 3" />
                </Grid>
                {/* Exercise TV 2 */}
                <Grid item xs={4}>
                    <Typography variant="h6" gutterBottom>Exercise TV 2</Typography>
                    <iframe src={exerciseTv2Url} style={verticalStyle} title="Exercise TV 2" />

                </Grid>
                {/* Exercise TV 1 */}
                <Grid item xs={4}>
                    <Typography variant="h6" gutterBottom>Exercise TV 1</Typography>

                    <iframe src={exerciseTv1Url} style={verticalStyle} title="Exercise TV 1" />

                </Grid>
            </Grid>

            {/* Header section with Timer, Movement, and Schedule TVs */}
            {/* Timer TV */}
            <Grid container spacing={2} style={{ height: 500 }}>
                <Grid item xs={6}>
                    <Typography variant="h6" gutterBottom>Timer TV</Typography>
                    <iframe src={timerTvUrl} style={horizontalStyle} title="Timer TV" />
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="h6" gutterBottom>Timer TV - Pre Workout</Typography>
                    <iframe src={movementTvUrl} style={horizontalStyle} title="Timer Pre Workout TV" />
                </Grid>
            </Grid>
            <Container style={{ height: 500 }}>

            </Container>

            {/* Schedule TV */}
            <Container>
                <Typography variant="h6" gutterBottom>Schedule TV</Typography>
                <iframe src={scheduleTvUrl} style={horizontalStyle} title="Schedule TV" />
            </Container>
        </Container>
    );
}
